export { default } from './EmprestimoGarantiaCarroSaber';
